/**
 * MESSAGING CONSTANTS
 *
 * All magic numbers and configuration values used in messaging system.
 * Centralized for easy modification and self-documenting code.
 */

// ============ TIMEOUTS ============

/** Timeout for MESSAGE_SENT confirmation before showing error (milliseconds) */
export const MESSAGE_SEND_TIMEOUT_MS = 5000

/** WebSocket ping timeout (milliseconds) */
export const WEBSOCKET_PING_TIMEOUT = 60000

/** WebSocket ping interval (milliseconds) */
export const WEBSOCKET_PING_INTERVAL = 25000

// ============ PAGINATION ============

/** Number of messages to load per page/request */
export const MESSAGES_PER_PAGE = 50

/** Maximum conversations to show in admin inbox */
export const INBOX_CONVERSATIONS_LIMIT = 100

// ============ IDENTIFIERS ============

/** Prefix for temporary optimistic message IDs */
export const TEMP_MESSAGE_PREFIX = 'temp-'

// ============ HTTP STATUS CODES ============

/** HTTP 429 Rate Limit Exceeded */
export const HTTP_STATUS_RATE_LIMIT = 429

// ============ SEARCH ============

/** Minimum search query length */
export const MIN_SEARCH_QUERY_LENGTH = 2

// ============ LOGGING EMOJIS ============

/** Console log emojis for consistent visual identification */
export const LOG_EMOJIS = {
  OUTGOING: '📤',
  INCOMING: '📥',
  WEBSOCKET: '🚀',
  REST: '📡',
  SUCCESS: '✅',
  ERROR: '❌',
  WARNING: '⚠️',
  STATE_UPDATE: '🔄',
  READ_RECEIPT: '🔵',
  OPTIMISTIC: '🎯',
  TIMEOUT: '⏱️',
  CLEANUP: '🗑️',
  NEW: '🆕',
  INFO: 'ℹ️'
} as const

/** Log emoji lookup by type */
export type LogEmojiType = keyof typeof LOG_EMOJIS
